import { createFileRoute } from '@tanstack/react-router';

import { EditLocationPage } from '../modules/locations/ui/pages/EditLocationPage';

export const Route = createFileRoute('/_authenticated/dashboard/locations/$locationId/edit')({
  component: EditLocationPage,
  staticData: {
    breadcrumb: ['Manage', 'Locations', 'Edit'],
  },
});
